<script setup>
import {
    ChevronDownIcon,
    SearchIcon,
    SortAscendingIcon,
} from "@heroicons/vue/solid";
import { ref } from "vue";

const query = ref("");
const emit = defineEmits(["search"]);

const search = async () => {
    if (query.value.length < 3) {
        return;
    }
    emit("search", query.value);
};
</script>
<template>
    <div class="pb-5 sm:flex sm:items-center sm:justify-between">
        <div class="mt-3 sm:mt-0 sm:ml-4">
            <label for="mobile-search-candidate" class="sr-only">Search</label>
            <label for="desktop-search-candidate" class="sr-only">Search</label>
            <div class="flex rounded-md shadow-sm">
                <div class="relative flex-grow focus-within:z-10">
                    <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                        <SearchIcon
                            class="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </div>
                    <input
                        type="text"
                        name="mobile-search-candidate"
                        id="mobile-search-candidate"
                        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:hidden border-gray-300"
                        placeholder="Search"
                    />
                    <input
                        type="text"
                        v-model="query"
                        name="desktop-search-candidate"
                        id="desktop-search-candidate"
                        class="hidden focus:ring-indigo-500 focus:border-indigo-500 w-full rounded-none rounded-l-md pl-10 sm:block sm:text-sm border-gray-300"
                        placeholder="Search for Id or Email"
                    />
                </div>
                <button
                    @click="search"
                    type="button"
                    class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                >
                    Search
                </button>
            </div>
        </div>
    </div>
</template>
